import _ from "lodash";
import {
  createAnonymousSession,
  fetchAccessToken,
  fetchIdTokenForLogInUser,
  setAccessToken,
} from "../services/commerceServices/accessToken";

// this function manages session token
export async function validateCommerceSession() {
  let tokens: any = {};
  try {
    tokens = JSON.parse(localStorage.getItem("commerce_token_storage") || "{}");
  } catch {
    tokens = {};
  }

  tokens.accessToken = tokens.accessToken || {};
  tokens.idToken = tokens.idToken || {};

  let { accessToken, idToken } = tokens;

  const now = Math.round(Date.now() / 1000);

  // ensure access token exists
  if (_.isEmpty(accessToken) || !accessToken.access_token) {
    await setAccessToken();

    try {
      tokens = JSON.parse(localStorage.getItem("commerce_token_storage") || "{}");
    } catch {
      tokens = {};
    }

    tokens.accessToken = tokens.accessToken || {};
    tokens.idToken = tokens.idToken || {};
    accessToken = tokens.accessToken;
    idToken = tokens.idToken;
  }

  // refresh access token if expired
  const accessTokenExpireAt = Number(accessToken?.expiryTime || 0);
  if (accessTokenExpireAt && accessTokenExpireAt < now) {
    const res: any = await fetchAccessToken();
    accessToken.access_token = res?.access_token;
    accessToken.expires_in = res?.expires_in;
    accessToken.expiryTime = now + Number(res?.expires_in || 0);
    localStorage.setItem("commerce_token_storage", JSON.stringify(tokens));
  }

  // determine whether we have a real okta session
  const oktaRawStr = localStorage.getItem("okta-token-storage");
  let oktaParsed: any = {};
  try {
    oktaParsed = oktaRawStr ? JSON.parse(oktaRawStr) : {};
  } catch {
    oktaParsed = {};
  }
  const hasRealOkta = !!oktaParsed?.idToken?.value;

  // helper: create/refresh anonymous session + store idToken
  const refreshAnonymous = async () => {
    const res: any = await createAnonymousSession(true);

    idToken.id_token = res?.securityToken?.idToken;
    idToken.partyId = res?.securityAccount?.partyId;
    idToken.accountId = res?.securityAccount?.accountId;

    const anonExpiresIn = Number(res?.securityToken?.expiresIn ?? 0);
    idToken.expiresAt = anonExpiresIn;
    idToken.expiryTime = now + anonExpiresIn;
  };

  // ensure id token exists or refresh if expired
  const idTokenExpireAt = Number(idToken?.expiryTime || 0);
  const missingIdToken = !idToken?.id_token;

  if (missingIdToken || (idTokenExpireAt && idTokenExpireAt < now)) {
    if (hasRealOkta) {
      try {
        const res: any = await fetchIdTokenForLogInUser();
        idToken.id_token = res?.id_token;
        idToken.expiresAt = res?.expires_in;
        idToken.expiryTime = now + Number(res?.expires_in || 0);
      } catch {
        await refreshAnonymous();
      }
    } else {
      await refreshAnonymous();
    }

    localStorage.setItem("commerce_token_storage", JSON.stringify(tokens));
  }
}